import { api } from './api';
import { LOGS } from './api/endpoints';

export const ActivityLogService = {
  getAll: (params) => api.get(LOGS.ALL, { params }),
  delete: (id) => api.delete(LOGS.DELETE(id)),
  getModuleOptions: () => api.get(LOGS.MODULE_OPTIONS),
};

export default ActivityLogService;
